/**
 * Section Pattern 7 – Scroll Opacity Animation
 */

document.addEventListener('DOMContentLoaded', () => {

    /** ---------------- CONFIGURABLE VARIABLES ---------------- **/
    const blockSelector       = '.section-pattern-7-block';
    const animationClass       = 'is-in-view';        // Class added when item is visible
    const itemSelector         = '.wp-block-accordion-item';
    const rootMargin           = '-15% 0px -18% 0px'; // Fade in/out slightly before fully visible
    const thresholds           = [0, 0.1, 0.2, 0.3];  // Multiple thresholds for smoother detection
    /** -------------------------------------------------------- **/

    // Select all blocks with scroll-opacity-animation
    const blocks = document.querySelectorAll(`${blockSelector} .scroll-opacity-animation`);
    if (!blocks.length) return; // Exit early if no blocks found

    // IntersectionObserver options
    const observerOptions = {
        root: null,
        rootMargin: rootMargin,
        threshold: thresholds
    };

    // Observer callback to toggle animation class
    const observerCallback = (entries) => {
        entries.forEach(entry => {
            if (!entry.target) return;

            if (entry.isIntersecting) {
                entry.target.classList.add(animationClass);
            } else {
                entry.target.classList.remove(animationClass);
            }
        });
    };

    // Initialize observer
    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each item inside each block
    blocks.forEach(block => {
        const items = block.querySelectorAll(itemSelector);
        if (!items.length) return; // Skip block if no items

        items.forEach(item => observer.observe(item));
    });

});